import { ISupplier } from '@bridebook/models/source/models/Suppliers.types';

export const STICKY_TABS_HEIGHT = 36;
export const STICKY_BOTTOM_BAR_HEIGHT = 80;

type SocialType = keyof NonNullable<ISupplier['social']>;
export const socialsListOrdered: SocialType[] = [
  'instagram',
  'tiktok',
  'facebook',
  'pinterest',
  'youtube',
  'vimeo',
  'linkedin',
  'twitter',
];
